// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .sidebar {
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    width: 200px;
  }
   */

/* Sidebar styling */
/* .sidebar {
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
  transition: transform 0.3s ease-in-out;
  padding: 10px;
}

.sidebar.closed {
  transform: translateX(-100%);
}

.sidebar.open {
  transform: translateX(0);
}

@media (max-width: 768px) {
  .sidebar {
    width: 250px;
  }
}

.table-responsive {
  overflow-x: auto;
}

.custom-table {
  width: 100%;
  background-color: #f8f9fa;
}

.table-dark th {
  background-color: #343a40;
  color: white;
}

.btn-close {
  font-size: 18px;
  cursor: pointer;
  background: transparent;
  border: none;
} */

/* ================ */

.sidebar-content {
  background-color: #396d72;
  height: 100vh;
  transition: transform 0.3s ease;
}

.sidebar-content.open {
  transform: translateX(0);
}

.sidebar-content.closed {
  transform: translateX(-100%);
}

.nav {
  /* padding: 20px; */
}

.nav-item {
  margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/style/Sidebar.css"],"names":[],"mappings":"AAAA;;;;;;;IAOI;;AAEJ,oBAAoB;AACpB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2CG;;AAEH,qBAAqB;;AAErB;EACE,yBAAyB;EACzB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* .sidebar {\n    height: 100vh;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 200px;\n  }\n   */\n\n/* Sidebar styling */\n/* .sidebar {\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  overflow-y: auto;\n  transition: transform 0.3s ease-in-out;\n  padding: 10px;\n}\n\n.sidebar.closed {\n  transform: translateX(-100%);\n}\n\n.sidebar.open {\n  transform: translateX(0);\n}\n\n@media (max-width: 768px) {\n  .sidebar {\n    width: 250px;\n  }\n}\n\n.table-responsive {\n  overflow-x: auto;\n}\n\n.custom-table {\n  width: 100%;\n  background-color: #f8f9fa;\n}\n\n.table-dark th {\n  background-color: #343a40;\n  color: white;\n}\n\n.btn-close {\n  font-size: 18px;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n} */\n\n/* ================ */\n\n.sidebar-content {\n  background-color: #396d72;\n  height: 100vh;\n  transition: transform 0.3s ease;\n}\n\n.sidebar-content.open {\n  transform: translateX(0);\n}\n\n.sidebar-content.closed {\n  transform: translateX(-100%);\n}\n\n.nav {\n  /* padding: 20px; */\n}\n\n.nav-item {\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
